import React from 'react';
import { AirportSearchInput } from '../../AirportSearchInput';

interface SearchBarProps {
  selectedAirport: string;
  onAirportSelect: (airportId: string) => void;
}

export function SearchBar({ selectedAirport, onAirportSelect }: SearchBarProps) {
  return (
    <div className="flex-1 max-w-2xl mx-auto w-full">
      {/* Mobile Layout */}
      <div className="lg:hidden">
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-white/5 rounded-2xl blur-xl"></div>
          <div className="relative">
            <AirportSearchInput 
              selectedAirport={selectedAirport}
              onSelect={onAirportSelect}
            />
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:block">
        <div className="relative group">
          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-white/10 rounded-2xl blur-xl group-hover:from-white/30 group-hover:to-white/20 transition-all duration-300"></div>
          <div className="relative bg-white/10 backdrop-blur-xl rounded-2xl border border-white/20 shadow-2xl group-hover:bg-white/15 group-hover:border-white/30 transition-all duration-300">
            <AirportSearchInput 
              selectedAirport={selectedAirport}
              onSelect={onAirportSelect}
            />
          </div>
        </div>
      </div>
    </div>
  );
}